<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<style scoped>
body {
  min-height: 100vh;
}

.wrapper {
  margin-top: 0;
}
</style>
<script>
import {mapGetters, mapActions} from 'vuex'
import Auth from '@/auth'
import myabftHeader from './components/Header'
import VueAnalytics from 'vue-analytics'
import {STORAGE_KEY} from "./vuex/local-storage";
import router from "./router/router";

var _ = require('lodash')
export default {
  name: 'App',
  data() {
    return {
      csrf: ""
    }
  },
  computed: {
    ...mapGetters({
      getAuth: 'getAuth'
    })
  },
  watch: {
    // 'getAuth.isLoggedIn': function () {
    //     let these = this
    //   console.log("getAuth.isLoggedIn")
    //   console.log(localStorage.getItem("abft_intranet"))
    //     if (this.getAuth.isLoggedIn)
    //         this.$http.post(process.env.API_URL + "getInfosMember").then((response) => {
    //                 these.setMember(response.body)
    //             }
    //         );
    // }
  },
  mounted: function () {
    let these = this

    // router.app.$options.store.state.stateLocalStorage.syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY))

    // console.log("getInfosMember")
    if (this.getAuth.isLoggedIn) {
      // this.checkVersion();
      this.$http.post(process.env.API_URL + "getInfosMember").then((response) => {
          these.setMember(response.body)
        }
      );
    }
  },
  methods: {
    ...mapActions({
      setMember: 'setMember',
      setDataToSyncedDataVuex: 'setDataToSyncedDataVuex'
    }),

    track() {
      this.$ga.page('/')
    },
    logout: function () {

    }
  },
  components: {
    myabftHeader
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue